document.addEventListener('DOMContentLoaded', function() {
  const minusButton = document.getElementById('minus-button');
  const plusButton = document.getElementById('plus-button');
  const quantityInput = document.getElementById('quantity-input');
  const addToCartButton = document.getElementById('add-to-cart-button');
  const variantButtons = document.querySelectorAll('.variant-button');
  const variantSelector = document.getElementById('variant-selector');
  const skuDisplay = document.getElementById('variant-sku');
  const barcodeDisplay = document.getElementById('variant-barcode');
  const productidDisplay = document.getElementById('product-id');
  const variantidDisplay = document.getElementById('variant-id');
  const priceDisplay = document.getElementById('product-price');
  const priceExcVatDisplay = document.getElementById('exvat-amount');
  const notifyLink = document.getElementById('notify-link');
  const selectedVariantTitle = document.getElementById('selected-variant-title');
  const compareAtPriceDisplay = document.getElementById('compare-at-price');
  const savingDisplay = document.getElementById('saving');
  const klarnaPaymentDisplay = document.getElementById('klarna-payment');
  const klarnaPriceDisplay = document.getElementById('product-klarna-price');
  const iwocaPaymentDisplay = document.getElementById('iwocapay-payment');
  const iwocaPriceDisplay = document.getElementById('product-iwoca-price');

  const productElement = document.querySelector('.product');
  const productId = productElement ? productElement.getAttribute('data-product-id') : null;

  // Currency symbol based on default currency
    const currencySymbol = defaultCurrency === 'USD' ? '$' :
                            defaultCurrency === 'EUR' ? '€' :
                            defaultCurrency === 'GBP' ? '£' :
                            defaultCurrency === 'PLN' ? 'zł' :
                            defaultCurrency === 'RON' ? 'lei' : '';

  function updateVariantDetails(element) {
    const title = element.getAttribute('data-title');
    const sku = element.getAttribute('data-sku');
    const barcode = element.getAttribute('data-barcode');
    const productid = element.getAttribute('data-product-id');
    const variantid = element.getAttribute('data-variant-id');
    const priceInCents = parseFloat(element.getAttribute('data-price')) || 0;
    const compareAtPriceInCents = parseFloat(element.getAttribute('data-compare-at-price')) || 0;
  
    const price = priceInCents / 100;
    const compareAtPrice = compareAtPriceInCents / 100;
  
    // Update general info
    if (selectedVariantTitle) selectedVariantTitle.textContent = title;
    if (skuDisplay) skuDisplay.textContent = sku;
    if (barcodeDisplay) barcodeDisplay.textContent = barcode;
    if (productidDisplay) productidDisplay.textContent = productid;
    if (variantidDisplay) variantidDisplay.textContent = variantid;
  
    // Update pricing
    if (priceDisplay) priceDisplay.innerText = formatPrice(price);
    if (priceExcVatDisplay) priceExcVatDisplay.innerText = formatPrice(price / vatAmount);
    if (klarnaPriceDisplay) klarnaPriceDisplay.innerText = formatPrice(price / splitPaymentOptions);
    if (iwocaPriceDisplay) iwocaPriceDisplay.innerText = formatPrice(price / 12);
  
    // Compare at and savings
    if (compareAtPrice > price) {
      if (compareAtPriceDisplay) {
        compareAtPriceDisplay.style.display = 'inline';
        compareAtPriceDisplay.innerText = formatPrice(compareAtPrice);
      }
      if (savingDisplay) {
        savingDisplay.style.display = 'inline';
        savingDisplay.innerText = formatPrice(compareAtPrice - price);
      }
    } else {
      if (compareAtPriceDisplay) compareAtPriceDisplay.style.display = 'none';
      if (savingDisplay) savingDisplay.style.display = 'none';
    }

}




  function selectFirstAvailableVariant() {
    let firstAvailableOption = null;

    if (variantSelector) {
      for (let i = 0; i < variantSelector.options.length; i++) {
        if (!variantSelector.options[i].hasAttribute('disabled')) {
          firstAvailableOption = variantSelector.options[i];
          variantSelector.selectedIndex = i;
          break;
        }
      }

      if (firstAvailableOption) {
        updateVariantDetails(firstAvailableOption);
      }
    } else if (variantButtons.length > 0) {
      variantButtons.forEach(button => {
        if (!button.hasAttribute('disabled') && firstAvailableOption === null) {
          firstAvailableOption = button;
        }
      });

      if (firstAvailableOption) {
        firstAvailableOption.classList.add('selected');
        updateVariantDetails(firstAvailableOption);
      }
    }
  }

  if (minusButton && plusButton && quantityInput) {
    minusButton.addEventListener('click', function() {
      let quantity = parseInt(quantityInput.value) || 1;
      if (quantity > 1) {
          quantityInput.value = quantity - 1;
      }
    });
    
    plusButton.addEventListener('click', function() {
        let quantity = parseInt(quantityInput.value) || 1;
        quantityInput.value = quantity + 1;
    });

}


  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
        const quantity = parseInt(quantityInput.value) || 1;
        const selectedVariantId = getSelectedVariantId() || productId;

        if (selectedVariantId) {
            addToCart(selectedVariantId, quantity);
        } else {
            alert('Please select a variant.');
        }
    });
}

// ✅ Now, the variant button event listeners will run correctly, even if addToCartButton does not exist.
variantButtons.forEach(button => {
  button.addEventListener('click', function () {
    if (this.hasAttribute('disabled')) return;

    variantButtons.forEach(btn => btn.classList.remove('selected'));
    this.classList.add('selected');
    updateVariantDetails(this);
  });
});


  if (variantSelector) {
    variantSelector.addEventListener('change', function() {
      const selectedOption = variantSelector.options[variantSelector.selectedIndex];
      updateVariantDetails(selectedOption);
    });

    // Select the first available variant
    selectFirstAvailableVariant();
  } 

  function getSelectedVariantId() {
    const selectedButton = document.querySelector('.variant-button.selected');
    if (selectedButton) {
        return selectedButton.getAttribute('data-variant-id');
    }
    if (variantSelector && variantSelector.value) {
        return variantSelector.value;
    }
    return productId; // Fallback to productId if nothing is selected
}

  function addToCart(itemId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: itemId,
          quantity: quantity
        }]
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('Product added to cart:', data);
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
  }

  // Initialize with the first variant's title
  selectFirstAvailableVariant();
});
